import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './table-skeleton.module.scss';
import useScreenType from '@/hooks/util/useScreenType';

interface TableSkeletonProps {
  rowCount?: number;
  columnCount?: number;
  rowHeight?: number;
}

export const TableSkeleton = ({
  rowCount = 5,
  columnCount = 3,
  rowHeight = 70,
}: TableSkeletonProps) => {
  const isMobile = useScreenType('mobile');

  return isMobile ? (
    <div className={styles.container}>
      <div className={styles.totalCountContainer}>
        <Skeleton height={17} width={100} borderRadius={8} />
      </div>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Skeleton key={rowIndex} height={rowHeight * 2} borderRadius={8} />
      ))}
    </div>
  ) : (
    <div className={styles.container}>
      <div className={styles.totalCountContainer}>
        <Skeleton height={17} width={100} borderRadius={8} />
      </div>

      <div className={styles.tableHeader}>
        {Array.from({ length: columnCount }).map((_, colIndex) => (
          <div key={colIndex} style={{ flex: 1 }}>
            <Skeleton height={32} width="100%" borderRadius={8} />
          </div>
        ))}
      </div>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Skeleton key={rowIndex} height={rowHeight} borderRadius={8} />
      ))}
    </div>
  );
};
